/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Actor_HumanInputs */

const en_directory_agents_actor_human = /** @type {(inputs: Directory_Agents_Actor_HumanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const zh_directory_agents_actor_human = /** @type {(inputs: Directory_Agents_Actor_HumanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Directory_Agents_Actor_HumanInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_actor_human = /** @type {((inputs?: Directory_Agents_Actor_HumanInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Actor_HumanInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_actor_human(inputs)
	return zh_directory_agents_actor_human(inputs)
});
export { directory_agents_actor_human as "directory.agents.actor_human" }